<template>
  <!-- 账号登录/注册 -->
  <div class="login-content df fdc">
    <div class="f1">
      <div class="title df">
        <span class="active">{{ $t("账号登录") }}</span>
      </div>

      <el-form ref="formdata" :model="formdata" :rules="rules">
        <!-- 手机号输入框 前面加上区号 -->
        <el-form-item prop="user_account">
          <div class="phone-input df">
            <el-input
              v-model="formdata.user_account"
              class="phone-input-item"
              :placeholder="$t('请输入账号')"
            />
          </div>
        </el-form-item>

        <el-form-item prop="user_pwd">
          <!-- 验证码输入框 -->
          <div class="phone-input df">
            <el-input
              v-model="formdata.user_pwd"
              :type="showpassword?'text':'password'"
              class="phone-input-item"
              :placeholder="$t('请输入密码')"
            />
            <span class="iconfont cup" :class="showpassword?'icon-yanjing1':'icon-yanjing2'" @click="showpassword=!showpassword"></span>
          </div>
        </el-form-item>

        <!-- 密码登录提示 -->
        <div class="password-login df aic jcsb">
          <el-button type="text" @click="handleCodeLogin(1)">{{
            $t("验证码登录")
          }}</el-button>
          <el-button
            type="text"
            @click="$navigate('/forget?callback='+callback, null, false)"
            class="forget-btn"
            >{{ $t("找回/创建密码") }}</el-button
          >
        </div>
      </el-form>
    </div>
    <!-- 登录按钮 -->
    <div class="login-button">
      <el-button type="primary" :loading="loading" @click="handleLogin">{{
        $t("登录")
      }}</el-button>
      <div class="mt-24 verify-box">
        <!-- 把这个多选变成圆形样式 -->
        <el-checkbox v-model="formdata.privacy" class="checkbox-circle">{{
          $t("我已阅读并同意")
        }}</el-checkbox
        ><span @click="handleDialogVisible('pri')"> {{ $t("隐私声明") }} </span>
        {{ $t("与") }}
        <span @click="handleDialogVisible('reg')">
          {{ $t("用户注册协议") }}</span
        >
      </div>
    </div>

    <!-- 弹框协议 -->
    <el-dialog
      :title="dialogTitle"
      :append-to-body="true"
      :z-index="2000"
      :visible.sync="dialogVisible"
    >
      <div class="dialog-content">
        <div class="dialog-content-item" v-html="dialogContent"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { userPriRegInfo } from "@api/user";
export default {
  data() {
    return {

      showpassword:false,

      loading:false,

      // 协议弹框
      dialogVisible: false,
      // 弹框title
      dialogTitle: "",
      // 弹框内容
      dialogContent: "",
      priReg: [],
      // 表单数据
      formdata: {
        // 账号
        user_account: "",
        // 密码
        user_pwd: "",
        // 隐私声明
        privacy: true,
      },
      rules: {
        user_account: [
          { required: true, message: this.$t("请输入账号"), trigger: "blur" },
          // {
          //     min: 3,
          //     max: 10,
          //     message: "长度在 3 到 10 个字符",
          //     trigger: "blur",
          // },
        ],
        user_pwd: [
          { required: true, message: this.$t("请输入密码"), trigger: "blur" },
          // { min: 6, message: "密码长度至少为 6 个字符", trigger: "blur" },
        ],
      },
      callback: '',
    };
  },

  // 接收参数 formdata
  // props: {
  //     formdata: {
  //         type: Object,
  //         default: () => {
  //             return {
  //                 phoneEmail: "phone",
  //                 phoneCode: "86",
  //             }
  //         }
  //     }
  // },
  // 监听参数 formdata
  // watch: {
  //     formdata: {
  //         handler(newVal) {
  //             this.propformdata = newVal;
  //         },
  //         immediate: true,
  //         deep: true
  //     },
  // },
  // 获取地址栏参数
  mounted() {
    this.getUserPriReg();
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    this.callback = urlParams.get("callback");
  },
  methods: {
    async getUserPriReg() {
      let res = await userPriRegInfo();
      this.priReg = res.data;
    },
    handleCodeLogin(type) {
      this.$emit("handleCodeLogin", type);
    },

    handleLogin() {
      let this_=this;
      this.loading=true;

      // 验证表单
      this.$refs.formdata.validate((valid) => {
        console.log(valid,".........")
        if (valid) {
          // 判断是否勾选隐私声明
          if (!this.formdata.privacy) {
            setTimeout(() => {
              this_.loading=false;
            }, 1000);
            this.$message.error(this.$t("请勾选隐私声明"));
            return;
          } else {
            setTimeout(() => {
              this_.loading=false;
            }, 2000);
            this.formdata.is_pwd_login = 1;
            this.$emit("handleLogin", this.formdata);
          }
        }else{
          setTimeout(() => {
              this_.loading=false;
            }, 50);
        }
      });
    },

    // 弹框协议
    handleDialogVisible(type) {
      this.dialogVisible = true;
      if (type == "pri") {
        this.dialogTitle = this.priReg.privacyPro.tsap_title;
        this.dialogContent = this.priReg.privacyPro.tsap_content;
      } else {
        this.dialogTitle = this.priReg.registerPro.tsap_title;
        this.dialogContent = this.priReg.registerPro.tsap_content;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep() {
  .el-input__inner:-webkit-autofill {
    background-color: transparent !important; /*在这里换成你想要的颜色*/
    transition: background-color 5000s ease-in-out 0s !important;
  }
  .el-input__inner:-webkit-autofill {
    background-color: transparent !important; /*在这里换成你想要的颜色*/
    transition: background-color 5000s ease-in-out 0s !important;
  }
  .el-dialog__body {
    max-height: calc(70vh - 54px);
    margin-bottom: 24px;
    padding: 24px 0;
    .dialog-content {
      width: 100%;
      max-height: calc(70vh - 102px);
      padding: 0 24px;
      overflow: hidden;
      overflow-y: scroll;
      // 设置滚动条样式
      &::-webkit-scrollbar {
        width: 4px;
        height: 8px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: #b7251e;
      }
    }
  }
  .el-form-item {
    margin-bottom: 0;
  }
}

.verify-box {
  font-size: 12px;
  line-height: 22px;
  color: #aeaeae;

  span {
    color: #b7251e;
    cursor: pointer;
  }

}

.checkbox-circle {
  ::v-deep() {
    .el-checkbox__inner {
      width: 19px;
      height: 19px;
      border-radius: 50%;
    }

    .el-checkbox__inner::after {
      width: 4px;
      left: 6px;
      top: 3px;
    }

    .el-checkbox__label {
      font-size: 12px;
      line-height: 22px;
      color: #aeaeae;
      padding-left: 6px;
    }
  }
}

* {
  font-family: "harmonyos";
  font-weight: 400;
}

::v-deep() {
  .el-radio__inner {
    width: 20px;
    height: 20px;
    border: 2px solid rgb(183, 37, 30) !important;
  }
}

.login-button {
  .el-button--primary {
    width: 100%;
    height: 40px;
    line-height: 40px;
    border-radius: 20px;
    padding: 0;
    background: rgb(183, 37, 30);
    color: rgb(255, 255, 255);
    font-size: 16px;
  }
}

.phone-input {

    height: 60px;
    border-radius: 8px;
    background: rgb(245, 248, 255);
    padding: 10px 16px;
    margin-top: 24px;

    ::v-deep() {
      .el-input--suffix .el-input__inner {
        border: none;
        background: transparent;
        padding-right: 0;

        color: rgb(179, 179, 179);

        font-size: 14px;
      }

      .el-input__inner {
        padding: 0;
        border: none;
        background: transparent;

        &::placeholder {
          color: rgb(179, 179, 179);
          font-size: 14px;
        }
      }

      .el-input__suffix {
        display: none;
      }
    }
 
}

.password-login {
  margin-top: 24px;

  ::v-deep() {
    .el-button {
      color: rgb(183, 37, 30);
      font-size: 16px;
      margin-top: 24px;
      padding: 0;
      margin: 0;
    }
    .el-button.forget-btn {
      color: #2673e5 !important;
    }
  }
}

.code-input {
  width: 400px;
  height: 60px;
  padding: 10px 16px 10px 16px;
  border-radius: 4px;
  background: rgb(245, 248, 255);
  margin-top: 24px;

  ::v-deep() {
    .el-input__inner {
      border: none;
      background: transparent;
      padding: 0;

      &::placeholder {
        color: rgb(179, 179, 179);
        font-size: 14px;
      }
    }

    .el-button {
      border: none;
      background: transparent;
      padding: 0;
      margin: 0;
      color: rgb(183, 37, 30);
      font-size: 14px;
    }
  }
}

.login-container {
  width: 100%;
  height: 100%;
  position: relative;

  .login-content {
    width: 520px;
    height: 600px;
    min-height: 500px;
    max-height: 100vh;
    border-radius: 16px;
    box-shadow: 0px 8px 24px 8px rgba(28, 57, 123, 0.08);
    background: rgb(255, 255, 255);
    padding: 80px 60px;
    position: absolute;
    right: 120px;
    top: 50%;
    transform: translateY(-50%);
  }

  .title {
    font-size: 20px;
    line-height: 30px;
    color: rgb(25, 25, 25);

    span {
      font-size: 20px;
      line-height: 30px;

      position: relative;
    }

    span.active::after {
      content: "";
      display: inline-block;
      width: 100%;
      height: 2px;
      background: #b7251e;
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
}
</style>